RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const MetricWidget = RivalIQ.apps.Dashboard.widgets.MetricWidget.extend({
        processProps: function (props) {
            const me = this;

            if (!_.isEmpty(me.getProp('searchTerm'))) {
                _.extend(me, {
                    metric: me.baseMetric.build({
                        value: 'N/A'
                    }),
                    submetric: {
                        displayString: 'Not Applicable When Searching'
                    }
                });
            } else {
                me.metric = me.baseMetric;
                me.submetric = me.baseSubmetric;
            }
            props = RivalIQ.apps.Dashboard.widgets.MetricWidget.prototype.processProps.call(me, props);

            return props;
        }
    });
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_METRIC, MetricWidget);

    const Glance = RivalIQ.apps.Dashboard.views.ColumnWidgets.extend({
        columnWidth: 3,
        panelView: undefined,
        className: 'panel-body',

        dashboardModelEvents: {
            'change': 'reload'
        },

        getPngView: function (child) {
            return child.getView();
        },

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.getWidgets();
        }
    });

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const GlanceWidget = Widget.extend({

        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        scheduledExportAdvancedSettingsEnabled: false,

        title: function () {
            const me = this;

            const storyDay = me.getProp('storyDay');
            if (storyDay) {
                return [moment.utc(storyDay).format('MMMM D, YYYY'), 'at a Glance'].join(' ');
            }

            let title = 'at a Glance';

            // If we're doing a panel export, insightsExportTitle puts the companyName in front of the title,
            // so don't double it up.
            if (!me.isExporting() || !me.isFocus() || me.isExportingPPT()) {
                const companyId = me.getProp('companyId');
                const company = RivalIQ.state.landscape.getCompanyById(companyId);
                title = `${company.get('name')} ${title}`;
            }

            return title;
        },

        processProps: function (props) {
            props.submetricDisplayType = 'upDownCarets';
            return props;
        },

        view: Glance,
        viewMore: false,
        propsToSerializeForExport: App.utils.widgetExportProps,

        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        }
    });

    const StoriesGlanceWidget = GlanceWidget.extend({

        description: RivalIQ.strings.instagram_insights_stories_glance_description,

        processProps: function (props) {
            const me = this;

            _.extend(props, {
                submetricType: 'delta_relative',
                submetricDisplayType: 'upDownCarets'
            });

            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric(RivalIQ.enums.insightsObjectType.storyDay, _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId']
                }, props));
            }
            _.extend(me.metric, props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const metric = new RivalIQ.models.MetricDefinition(me.metric);

            return [
                {
                    instanceId: 'days-with-story',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        property: 'days_with_story',
                        name: 'Stories'
                    }),
                    submetric: metric.build({
                        property: 'days_with_story',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                    })
                },
                {
                    instanceId: 'stories-per-day',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        property: 'stories_per_day'
                    }),
                    submetric: metric.build({
                        property: 'stories_per_day',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                    })
                },
                {
                    instanceId: 'max-reach-per-day',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        property: 'max_reach_per_day'
                    }),
                    submetric: metric.build({
                        property: 'max_reach_per_day',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                    })
                },
                {
                    instanceId: 'completion-rate-per-day',
                    widgetId: RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_METRIC,
                    baseMetric: metric.build({
                        property: 'stories_retention_rate'
                    }),
                    baseSubmetric: metric.build({
                        property: 'stories_retention_rate',
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                    })
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORIES_AT_A_GLANCE, StoriesGlanceWidget);

    const StoryDayGlanceWidget = GlanceWidget.extend({

        description: RivalIQ.strings.instagram_insights_frames_glance_description,

        processProps: function (props) {
            const me = this;

            props.doNotRebuildMetrics = true;

            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric(RivalIQ.enums.insightsObjectType.storyDay, _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'storyDay'],
                    limit: 1
                }, props));
            }
            _.extend(me.metric, props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const props = me.getProps();
            const metric = new RivalIQ.models.MetricDefinition(me.metric);
            const compareMetric = App.utils.buildStoryDayCompareMetric(metric);

            return [
                {
                    instanceId: 'num-stories',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        name: 'Number of Frames',
                        property: 'num_stories'
                    }),
                    submetric: compareMetric.build({
                        property: 'stories_per_day'
                    })
                },

                {
                    instanceId: 'max-reach',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        property: 'max_reach',
                        companyId: props.companyId
                    }),
                    submetric: compareMetric.build({
                        property: 'max_reach_per_day'
                    })
                },

                {
                    instanceId: 'completion-rate',
                    widgetId: RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_METRIC,
                    baseMetric: metric.build({
                        property: 'stories_retention_rate',
                        companyId: props.companyId
                    }),
                    baseSubmetric: compareMetric.build({
                        property: 'stories_retention_rate'
                    })
                },

                {
                    instanceId: 'replies',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.build({
                        property: 'replies',
                        companyId: props.companyId
                    }),
                    submetric: compareMetric.build({
                        property: 'replies_per_day'
                    })
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_STORYDAY_AT_A_GLANCE, StoryDayGlanceWidget);


    function getInstagramWidgetDefinitions(dashboardModel, metric) {
        const impressionsPerPostProperty = 'impressions_per_post';
        let engagementTotalProperty = 'engagement_total';
        let engagementRatePerPostProperty = 'engagement_rate_by_impression';

        if (!App.utils.hasInstagramPaidEngagement(dashboardModel)) {
            engagementTotalProperty = 'organic_engagement_total';
            engagementRatePerPostProperty = 'organic_engagement_rate_by_impression';
        }

        return [
            {
                instanceId: 'posts-activity',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count'
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'impressions_per_post',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: impressionsPerPostProperty
                }),
                submetric: metric.build({
                    property: impressionsPerPostProperty,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_total',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: engagementTotalProperty
                }),
                submetric: metric.build({
                    property: engagementTotalProperty,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_rate_by_impression',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: engagementRatePerPostProperty
                }),
                submetric: metric.build({
                    property: engagementRatePerPostProperty,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            }
        ];
    }

    function getLinkedInWidgetDefinitions(metric) {
        return [
            {
                instanceId: 'posts-activity',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count'
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'impressions_per_post',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'impressions_per_post'
                }),
                submetric: metric.build({
                    property: 'impressions_per_post',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_total',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'engagement_total'
                }),
                submetric: metric.build({
                    property: 'engagement_total',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_rate_by_impression',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'engagement_rate_by_impression'
                }),
                submetric: metric.build({
                    property: 'engagement_rate_by_impression',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            }
        ];
    }

    function getTwitterWidgetDefinitions(metric) {
        return [
            {
                instanceId: 'count',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count'
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'impressions_per_post',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'impressions_per_post'
                }),
                submetric: metric.build({
                    property: 'impressions_per_post',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_total',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'engagement_total'
                }),
                submetric: metric.build({
                    property: 'engagement_total',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_rate_by_impression',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'engagement_rate_by_impression'
                }),
                submetric: metric.build({
                    property: 'engagement_rate_by_impression',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            }
        ];
    }

    function getFacebookWidgetDefinitions(metric) {
        return [
            {
                instanceId: 'posts-activity',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count',
                    description: RivalIQ.strings.facebook_insights_posts_count_description
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'impressions_per_post',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'impressions_per_post'
                }),
                submetric: metric.build({
                    property: 'impressions_per_post',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_total',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'engagement_total'
                }),
                submetric: metric.build({
                    property: 'engagement_total',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })
            },
            {
                instanceId: 'engagement_rate_by_impression',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'engagement_rate_by_impression'
                }),
                submetric: metric.build({
                    property: 'engagement_rate_by_impression',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                })

            }
        ];
    }

    const PostsGlanceWidget = GlanceWidget.extend({

        description: function () {
            const me = this;

            switch (me.getProp('source')) {
                case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
                    return RivalIQ.strings.facebook_insights_posts_glance_description;

                case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
                    return RivalIQ.strings.instagram_insights_posts_glance_description;

                case RivalIQ.enums.sources.LINKEDIN:
                    return RivalIQ.strings.linked_in_insights_posts_glance_description;

                case RivalIQ.enums.sources.TWITTER_INSIGHTS:
                    return RivalIQ.strings.twitter_insights_posts_glance_description;

                default:
                    throw new Error(`Post Glance Widget - unknown source ${me.getProp('source')}`);
            }
        },

        filter: function () {
            const me = this;
            return RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(me);
        },

        processProps: function (props) {
            const me = this;

            _.extend(props, {
                submetricType: 'delta_relative',
                submetricDisplayType: 'upDownCarets'
            });

            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric(RivalIQ.enums.insightsObjectType.post, _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId']
                }, props));
            }
            _.extend(me.metric, props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const metric = new RivalIQ.models.MetricDefinition(me.metric);
            let widgets;

            switch (me.getProp('channel')) {
                case 'instagram':
                    widgets = getInstagramWidgetDefinitions(me, metric);
                    break;

                case 'linkedin':
                    widgets = getLinkedInWidgetDefinitions(metric);
                    break;

                case 'facebook':
                    widgets = getFacebookWidgetDefinitions(metric);
                    break;

                case 'twitter':
                    widgets = getTwitterWidgetDefinitions(metric);
                    break;
                default:
                    throw new Error(`unknown channel ${me.getProp('channel')}`);
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_POSTS_AT_A_GLANCE, PostsGlanceWidget);

}, window.moment);
